import axiosServices from "../utils/axios";
import { formatDate } from "../utils/date-helper";

interface FetchHistoryApiResponse {
  data: {
    new_val: {
      [key: string]: string;
    };
    old_val: {
      [key: string]: string;
    };
    created_dt: string;
    user: string | null;
    updated_by: string | null;
    table: string;
    key_id: string;
    op: string;
  }[];
}

const transformData = (history: FetchHistoryApiResponse) =>
  history.data
    .flatMap((entry) =>
      Object.keys(entry.new_val)
        .filter((key) => entry.new_val[key] || entry.old_val?.[key])
        .map((key) => {
          const newValue = entry.new_val[key];
          const oldValue = entry.old_val?.[key] ?? "No old value";

          return {
            newValue:
              typeof newValue === "object" && newValue !== null
                ? JSON.stringify(newValue)
                : newValue,
            oldValue:
              typeof oldValue === "object" && oldValue !== null
                ? JSON.stringify(oldValue)
                : oldValue,
            user: entry.user,
            fieldChanges: key,
            date: new Date(entry.created_dt),
            table: entry.table,
          };
        })
    )
    .sort((a, b) => b.date.getTime() - a.date.getTime())
    .map((historyData, index) => ({
      ...historyData,
      id: index + 1,
      date: formatDate(historyData.date),
  }));

export const fetchHistoryData = async (keyId: string, tableName: string) => {
  const response = await axiosServices.get<FetchHistoryApiResponse>(
    "/data/history",
    {
      params: {
        keyId,
        tableName,
      },
    }
  );
  return transformData(response.data);
};
